import is from 'is_js'
import classNames from 'classnames'
import styles from './Date.scss'

const maybeConvertValue = (v) => {
  if (is.nan(v) || is.null(v)) return ''
  return v
}

const Date = ({ type, setValue, value, error }) => (
  <div
    className={classNames(styles.base, {
      [styles.error]: error,
    })}
  >
    <input
      type={type}
      style={{ textTransform: 'uppercase' }}
      onChange={(e) => setValue(e.target.value)}
      value={maybeConvertValue(value)}
    />
  </div>
)

Date.defaultProps = {
  error: false,
}
Date.propTypes = {}

export default Date
